<template>
  <div>
    <b-container  class="bv-example-row">
      <b-row cols="4" cols-sm="1" cos-md="2" cols-lg="4">
        <InfoLinkCard
            title="Customers"
            label="SignedUp"
            :counter=cnt.customers
            link="Customers"
            :is-loading="isLoading"
        />
        <InfoLinkCard
            title="Manage devices"
            label="Active devices"
            :counter=cnt.devices
            link="DevicesContainer"
            :is-loading="isLoading"
        />
      </b-row>

      <b-row class="border mx-0 my-3">
      </b-row>
      <b-row cols="2" cols-sm="1" cos-md="1" cols-lg="2" >
        <DeviceWarnings
            :dgfeWarning=dgfeAlertsCount
            :periodicVerification=periodicVerificationCount
            :is-loading=isLoading
        ></DeviceWarnings>
        <b-col cols="12"  class="mt-3 mb-2">
          <b-card>
            <chart-title chart-title="Chart device by type"></chart-title>
            <NothingToShow :is-loading="isLoading" :is-there-date="deviceByType.labels.length > 0">
              <DoughnutChart
                :chartData="deviceByType"
                :width=200
                :height=120
              />
            </NothingToShow>
          </b-card>
        </b-col>
        <b-col cols="12" class="mt-3 mb-2">
          <b-card>
            <chart-title chart-title="Chart device activity" class="mb-2"></chart-title>
            <NothingToShow :is-loading="isLoading" :is-there-date="deviceActivity.labels.length > 0">
              <DoughnutChart
                :chartData="deviceActivity"
                :width=200
                :height=100
                :max-legend-lable-lenght="35"
                class="fix"
              />
            </NothingToShow>
          </b-card>
        </b-col>
        <b-col cols="12" class="mt-3 mb-2" >
          <b-card>
            <ChartFirmwareUpdateByDeviceType
                :userDeviceTypes="deviceInfo"
                :is-loading="isLoading"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import InfoLinkCard from "../components/InfoLinkCard.vue";
import DoughnutChart from "./charts/DoughnutChart";

import {randomHexColorWithArray} from 'random-hex-color-generator';
import DeviceWarnings from "../components/DeviceWarnings.vue";
import ChartFirmwareUpdateByDeviceType from "../components/ChartFirmwareUpdateByDeviceType.vue";
import ChartTitle from "../components/ChartTitle.vue";
import NothingToShow from "../components/NothingToShow.vue";

export default {
  name: "dashboard",
  components: {NothingToShow, ChartTitle, ChartFirmwareUpdateByDeviceType, DeviceWarnings, InfoLinkCard, DoughnutChart},
  data: () => ({
    chartConfiguration: {
      plugins: {
        legend: {
          position: 'right'
        }
      }
    },
    isLoading: true,
    // counters
    cnt: {
      customers: 0,
      devices: 0,
      // ats_licenses: 0,
      // ats3_licenses: 0,
      isLoading: true
    },

    // device by type
    deviceByType: {
      labels: [],
      datasets: [

      ]
    },
    deviceActivity: {
      labels: [],
      datasets: [

      ]
    },
    deviceTypes: [],
    deviceInfo: [],
    // alerts
    dgfeAlertsCount: 0,
    dgfeAlertsDevices: {
      type: [],
      default: []
    },
    periodicVerificationCount: 0,
    periodicVerificationDevices: {
      type: [],
      default: []
    },
  }),
  mounted() {
    Promise.all(
        [
            this.loadDashboardCountersData(),
            this.loadDashboardDeviceByTypeData(),
            this.loadDeviceActivityData(),
            this.loadAlertsData(),
        ]
    ).finally(
        () => {
          this.isLoading = false;
        }
    );

  },
  methods: {
    loadDashboardCountersData() {
      let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/summary/counters`;

      return axios.get(url).then(({data}) => {
        data = this.handleNullResponse(data);
        this.updateDashBoardCounters(data);
        return data;
      }).catch(e => {
        console.log(e);
      });
    },
    loadDashboardDeviceByTypeData() {
      let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/summary/devices-by-type`;

      return axios.get(url).then(({data}) => {
        data = this.handleNullResponse(data);
        this.updateDeviceByType(data);
        return data;
      }).catch(e => {
        console.log(e);
      });
    },
    loadDeviceActivityData() {
      let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/summary/devices-activity`;

      return axios.get(url).then(({data}) => {
        data = this.handleNullResponse(data);
        this.updateDeviceActivity(data);
        return data;
      }).catch(e => {
        console.log(e);
      });
    },

    loadAlertsData() {
      let urlDgfe = `${this.$store.getters.getAppUrl}/dealer/api/v2/alerts/dgfe`;
      let urlPeriodicVerification = `${this.$store.getters.getAppUrl}/dealer/api/v2/alerts/periodic-verification`;

      return axios.all([
        axios.get(urlDgfe),
        axios.get(urlPeriodicVerification),
      ]).then(axios.spread((dataDgfe, dataPeriodicVerification) => {

        this.updateAlerts({dataDgfe, dataPeriodicVerification});
      }));

    },

    updateDashBoardCounters(response) {
      this.cnt = Object.assign(this.cnt, response.data);
      this.cnt.isLoading = false;
    },
    handleNullResponse(response) {
      if (!response) {
        response = {};
      }
      if (!response.data)
        response.data = [];
      return response;
    },

    updateDeviceByType(response) {
      this.deviceTypes = _.map(response.data, 'commercial_name');

      this.deviceInfo = response.data;

      // this.deviceIds = _.map(response.data, 'id');
      this.deviceByType = {
        labels: _.map(response.data, 'commercial_name'),
        datasets: [
          {
            data: _.map(response.data, 'percentage'),
            backgroundColor: randomHexColorWithArray(response.data.length+1),
          }
        ]
      };
    },

    updateDeviceActivity(response) {
      this.deviceActivity = {
        labels: _.map(response.data, 'label')
          .map((label) => this.$t(label)),
        datasets: [
          {
            // backgroundColor: randomHexColorWithArray(response.data.length+1),
            backgroundColor: [
              "#03e243",
              "#aab400",
              "#ed5e10",
              "#f22149",
            ],
            data: _.map(response.data, 'percentage'),
          }
        ]
      }

      var pipo = 3;
    },
    updateAlerts(param) {
      this.dgfeAlertsCount = param.dataDgfe.data.data.count;
      this.dgfeAlertsDevices = param.dataDgfe.data.data.devices;
      this.periodicVerificationCount = param.dataPeriodicVerification.data.data.count;
      this.periodicVerificationDevices = param.dataPeriodicVerification.data.data.devices;
    },

  }
}
</script>



<style scoped>
  .fix{
    margin-top: 80px;
    margin-bottom: 20px;
  }

  .chat-place-holder{
    text-align: center;
    padding: 120px 0;

  }
</style>
